import PropTypes from 'prop-types';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
export const upgradeDataPropsInterface = {
  upgradeData: PropTypes.shape({
    app: PropTypes.string.isRequired,
    screen: PropTypes.string.isRequired,
    upgradeProduct: PropTypes.oneOf(Object.values(UpgradeProducts)).isRequired,
    uniqueId: PropTypes.string.isRequired
  }).isRequired
};